<template>
  <div class="currency-record">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="支付类型">
        <Select v-model="searchCondition.pay_type" class="com-width" clearable>
          <Option v-for="item in payType" :value="item.key" :key="item.key">{{
            item.value
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="支付终端">
        <Select v-model="searchCondition.tag_type" class="com-width" clearable>
          <Option v-for="item in tagType" :value="item.key" :key="item.key">{{
            item.value
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="状态">
        <Select v-model="searchCondition.status" class="com-width" clearable>
          <Option
            v-for="item in paymentsStatus"
            :value="item.key"
            :key="item.key"
            >{{ item.value }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="支付时间">
        <DatePicker
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width: 280px"
          @on-change="onDateRange"
          :editable="false"
          clearable
        ></DatePicker>
      </FormItem>
      <FormItem label="订单号">
        <Input
          v-model="searchCondition.order_number"
          placeholder="请输入订单号"
          style="width: 200px"
          clearable
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入订单用户手机号"
          style="width: 200px"
          clearable
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/orderPayments"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="order_number"
        method="get"
      ></Grid>
    </div>
  </div>
</template>

<script>
import { PayType, Terminal, PaymentsStatus } from "@/utils/enums";

export default {
  name: "currency-record",
  data() {
    return {
      payType: PayType.getOptions(),
      tagType: Terminal.getOptions(),
      paymentsStatus: PaymentsStatus.getOptions(),
      searchCondition: {
        pay_type: "",
        tag_type: "",
        status: "",
        payed_start: "",
        payed_end: "",
        order_number: "",
        mobile: "",
        init() {
          this.pay_type = "";
          this.tag_type = "";
          this.status = "";
          this.payed_start = "";
          this.payed_end = "";
          this.order_number = "";
          this.mobile = "";
        },
      },
      tableColumns: [
        {
          title: "付款单编号",
          key: "payment_number",
          align: "center",
          minWidth: 200,
        },
        {
          title: "订单编号",
          key: "order_number",
          align: "center",
          minWidth: 200,
        },
        {
          title: "交易流水号",
          key: "trade_no",
          align: "center",
          minWidth: 200,
        },
        { title: "用户手机号", key: "mobile", align: "center", minWidth: 130 },
        { title: "支付金额", key: "pay_price", align: "center", minWidth: 90 },
        {
          title: "支付类型",
          key: "pay_type_name",
          align: "center",
          minWidth: 90,
        },
        {
          title: "支付终端",
          key: "tag_type_name",
          align: "center",
          minWidth: 90,
        },
        { title: "状态", key: "status_name", align: "center", minWidth: 90 },
        {
          title: "创建时间",
          key: "begin_time",
          align: "center",
          minWidth: 150,
        },
        {
          title: "支付时间",
          key: "payed_time",
          align: "center",
          minWidth: 150,
        },
      ],
    };
  },
  methods: {
    // on event
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.formDate.handleClear();
      this.$refs.grid.searchRefresh();
    },
    onDateRange(range) {
      this.searchCondition.payed_start = range[0];
      this.searchCondition.payed_end = range[1];
    },
    onrowsFormatter(rows) {
      rows.forEach((i) => {
        i.pay_price = this.$pub.calcPrice(i.pay_price);
        i.pay_type_name = PayType.getValue(i.pay_type);
        i.tag_type_name = Terminal.getValue(i.tag_type);
        i.status_name = PaymentsStatus.getValue(i.status);
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
